export default __webpack_public_path__ + "static/assets/med_pill_elipse_flat_L1_solid_x_01_f.a0160f35.png";